import { useState } from "react";
import Box from "@amzn/meridian/esm/components/box";
import Button from "@amzn/meridian/esm/components/button";
import Column from "@amzn/meridian/esm/components/column";
import Icon from "@amzn/meridian/esm/components/icon";
import Input from "@amzn/meridian/esm/components/input";
import Row from "@amzn/meridian/esm/components/row";
import sendSmallTokens from "@amzn/meridian-tokens/base/icon/send-small";
import Theme from "@amzn/meridian/esm/components/theme";
import Tooltip from "@amzn/meridian/esm/components/tooltip";
import newSessionIcon from "../../../../images/new_session.svg";

const ChatInput = ({ onSend, onNewSession, disabled }) => {
  const [message, setMessage] = useState("");

  const handleSend = () => {
    if (disabled || !message.trim()) return;
    if (onSend) onSend(message.trim());
    setMessage("");
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };

  return (
    <Column width="318px" spacing="none">
        <Box type="outline" width="318px" height="48px">
          <Column alignmentVertical="center" height="48px" spacingInset="0 300">
            <Row spacing="none" alignmentVertical="center" widths={["fit", "fill", "fit"]}>
              <Theme tokens={{ buttonSpacingInsetHorizontalSmall: 4, buttonHeightSmall: 32 }}>
                <Tooltip position="end" title="New chat" id="newChatTooltip">
                  <Button type="icon" size="small" onClick={onNewSession} disabled={disabled} aria-describedby="newChatTooltip">
                    <img src={newSessionIcon} alt="new session" />
                  </Button>
                </Tooltip>
              </Theme>
              <div className="chat-input-no-shadow">
                <Theme tokens={{
                  inputTextMediumFontSize: "14px",
                  inputBackgroundColorDisabled: "#FFFFFF",
                  inputPlaceholderColorDisabled: "#575F67",
                }}>
                  <Input
                    value={message}
                    onChange={setMessage}
                    onKeyDown={handleKeyDown}
                    placeholder="Ask assistant"
                    size="medium"
                    type="text"
                    disabled={disabled}
                  />
                </Theme>
              </div>
              <Tooltip position="start" title="Send" id="sendTooltip">
                <Theme tokens={{
                  buttonBackgroundColorPrimaryDisabled: "#006D5B",
                  buttonForegroundColorPrimaryDisabled: "#FFFFFF",
                }}>
                  <Button type="primary" size="small" onClick={handleSend} disabled={disabled} aria-describedby="sendTooltip">
                    <Icon tokens={sendSmallTokens}>Send</Icon>
                  </Button>
                </Theme>
              </Tooltip>
            </Row>
          </Column>
        </Box>
      </Column>
  );
};

export default ChatInput;
